export default {
    addCompanyContact: 'Add Company Information',
    addPersonalContact: 'Add a Personal Contact',
    archiveClient: 'Archive Client',
    delete: 'Delete',
    title: 'Client - MakeLeaps',
};
